import { render, staticRenderFns } from "./VaImageDragAndDropInput.vue?vue&type=template&id=28ec4e6c&scoped=true&"
import script from "./VaImageDragAndDropInput.vue?vue&type=script&lang=js&"
export * from "./VaImageDragAndDropInput.vue?vue&type=script&lang=js&"
import style0 from "./VaImageDragAndDropInput.vue?vue&type=style&index=0&id=28ec4e6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec4e6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
